import styled, { createGlobalStyle } from 'styled-components';

/** Global overrides for `.m-chat-thumb-tooltip` + `.m-tooltip-top` (pseudo-elements from mi-ui-global-styles). */
export const ThumbTooltipGlobalStyles = createGlobalStyle`
  @media not ((hover: hover) and (pointer: fine)) {
    .m-chat-thumb-tooltip.m-tooltip-top:hover.m-tooltip-top::before,
    .m-chat-thumb-tooltip.m-tooltip-top:hover.m-tooltip-top::after {
      display: none !important;
      content: none !important;
      border: none !important;
      box-shadow: none !important;
      background: none !important;
      padding: 0 !important;
      margin: 0 !important;
      width: 0 !important;
      height: 0 !important;
      min-width: 0 !important;
      max-width: 0 !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }
  }

  @media (hover: none) {
    .m-chat-thumb-tooltip.m-tooltip-top:hover.m-tooltip-top::before,
    .m-chat-thumb-tooltip.m-tooltip-top:hover.m-tooltip-top::after {
      display: none !important;
      content: none !important;
      border: none !important;
      box-shadow: none !important;
      background: none !important;
      padding: 0 !important;
      margin: 0 !important;
      width: 0 !important;
      height: 0 !important;
      min-width: 0 !important;
      max-width: 0 !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }
  }

  .m-chat-thumb-tooltip.m-tooltip-top:hover.m-tooltip-top::after {
    padding: 4px 8px !important;
    min-width: unset !important;
  }
`;

export const Wrapper = styled.div`
  border-top: 1px solid var(--t-horizontal-vertical-rule, #c4c4c4);
`;

export const IconButton = styled.button<{ $selected?: boolean }>`
  border: none;
  background: transparent;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  color: var(--t-brand-alt-color, #707070);
  line-height: 0;
  transition: background-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;

  /* AIcon root span defaults to --t-brand-fg-color; inherit button color for default/hover/selected */
  & > span {
    color: inherit;
  }

  &:hover:not(:disabled):not([aria-disabled='true']) {
    background: var(--t-icon-btn-primary-bg-color, #eeeeee);
    color: var(--t-brand-fg-color, #1c1c1c);
  }

  &:focus {
    outline: none;
  }

  /* Keyboard / focus-visible: match hover fill; webkit ring aligned with chat ADA pattern */
  &:focus-visible:not(:disabled):not([aria-disabled='true']) {
    outline: -webkit-focus-ring-color auto 1px;
    background: var(--t-icon-btn-primary-bg-color, #eeeeee);
    color: var(--t-brand-fg-color, #1c1c1c);
  }

  &:disabled,
  &[aria-disabled='true'] {
    cursor: default;
    opacity: 1;
  }

  ${p =>
    p.$selected &&
    `
    color: #1c1c1c;
    background: var(--t-icon-btn-primary-bg-color, #eeeeee);
  `}
`;
